<div class="pagination">
    <div *ngIf="showPages" class="page-size">Items per page: {{pagination.pageSize}}</div>
    <div *ngIf="showPages">
        <button mat-icon-button title="Previous page" [disabled]="!pagination.hasPreviousPage" (click)="pageChangeRequest(pagination.currentPage - 1)">
            <mat-icon>keyboard_arrow_left</mat-icon>
        </button>
        <button mat-icon-button *ngFor="let page of range(1, pagination.totalPages)" [title]="'Page ' + page" [disabled]="pagination.currentPage == page" (click)="pageChangeRequest(page)">
            {{page}}
        </button>
        <button mat-icon-button title="Next page" [disabled]="!pagination.hasNextPage" (click)="pageChangeRequest(pagination.currentPage + 1)">
            <mat-icon>keyboard_arrow_right</mat-icon>
        </button>
    </div>
    <div class="page-size">Total items: {{pagination.totalCount}}</div>
</div>